import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  IconButton,
  TextField,
  toast,
  Typography,
} from "@suraasa/placebo-ui"
import { useQueryClient } from "@tanstack/react-query"
import { Xmark } from "iconoir-react"
import { useForm } from "react-hook-form"

import { API } from "@/api"
import { APIQueries } from "@/api/queries"
import { useClubId } from "@/lib/hooks/use-club-id"
import { mapErrors } from "@/lib/map-errors"
import { sleep } from "@/lib/utils"

type Props = {
  open: boolean
  handleClose: () => void
}

// type SelectOptionType = {
//   label: string
//   value: string
// }

type FormData = {
  name: string
  adminEmail: string
  // curricula: SelectOptionType[]
  adminName: string
}

const AddSchoolDialog = ({ open, handleClose }: Props) => {
  const {
    handleSubmit,
    register,
    setError,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<FormData>()

  const clubId = useClubId()

  // const { curriculum } = useResource(["curriculum"])

  const queryClient = useQueryClient()

  const onSubmit = handleSubmit(async (formData) => {
    try {
      await API.organization.create({
        urlParams: {
          id: clubId,
        },
        data: {
          name: formData.name,
          adminEmail: formData.adminEmail,
          adminName: formData.adminName,
          source: "suraasa_kind",
          // curricula: formData.curricula.map((i) => i.label),
        },
      })

      await sleep(100)

      await queryClient.invalidateQueries({
        queryKey: APIQueries.organization.list({
          fields: ["name", "teachers_count", "date_created"],
        }).queryKey,
      })

      toast.success("School has been added successfully!")
      closeDialog()
    } catch (e) {
      mapErrors(e, {
        setter: setError,
        fields: [["name"], ["adminEmail"], ["adminName"]],
      })
    }
  })

  const closeDialog = () => {
    reset()
    handleClose()
  }

  // const curricula = useWatch({
  //   control,
  //   name: "curricula",
  // })

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent closeWhenInteractOutside>
        <div className="flex flex-col">
          <div className="m-2.5 flex flex-row items-center justify-between">
            <Typography className="text-title3 text-onSurface-900">
              Add School
            </Typography>
            <IconButton onClick={closeDialog}>
              <Xmark className="text-onSurface-700" />
            </IconButton>
          </div>
          <div className="flex flex-col">
            <Typography
              className="px-2.5 pb-3 text-onSurface-500"
              variant="body"
            >
              Enter the school's details to add them to your club's directory.
            </Typography>
            <form onSubmit={onSubmit}>
              <div className="px-2.5 pb-2.5">
                <TextField
                  required
                  type="text"
                  errors={errors.name?.message}
                  label="Name"
                  className="mb-3 w-full"
                  placeholder="Enter School Name"
                  {...register("name", {
                    required: { value: true, message: "Required" },
                  })}
                />

                {/* <div>
                  <Controller
                    control={control}
                    name="curricula"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <>
                        <div className="flex items-center justify-between">
                          <InputLabel label="Curriculum Board(s)" required />
                          {curricula?.length > 0 && (
                            <Button
                              variant="text"
                              onClick={() => {
                                setValue("curricula", [])
                              }}
                            >
                              Clear
                            </Button>
                          )}
                        </div>
                        <CreatableSelect
                          required
                          className="mb-3"
                          errors={errors.curricula?.message}
                          options={curriculum.map((i) => ({
                            label: i.name,
                            value: i.uuid,
                          }))}
                          creatableMessage="You can add Boards by typing"
                          placeholder="Select Board"
                          mountOnBody
                          isMulti
                          onBlur={onBlur}
                          isClearable
                          value={value}
                          onChange={onChange}
                        />
                      </>
                    )}
                    rules={{
                      required: { value: true, message: "Required" },
                    }}
                  />
                </div> */}
                <TextField
                  required
                  type="email"
                  errors={errors.adminEmail?.message}
                  label="Email Address"
                  className="mb-3 w-full"
                  placeholder="Ex: email@provider.com"
                  {...register("adminEmail", {
                    required: { value: true, message: "Required" },
                  })}
                />
                <TextField
                  required
                  type="text"
                  errors={errors.adminName?.message}
                  label="Admin Name"
                  className="mb-3 w-full"
                  placeholder="Add Admin Name"
                  {...register("adminName", {
                    required: { value: true, message: "Required" },
                  })}
                />
              </div>

              <DialogFooter>
                <Button
                  type="submit"
                  onClick={onSubmit}
                  color={"black"}
                  loading={isSubmitting}
                >
                  Add School
                </Button>
              </DialogFooter>
            </form>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default AddSchoolDialog
